// extracted by mini-css-extract-plugin
module.exports = {"container":"_9e1425b4d3--container--FDs93","text":"_9e1425b4d3--text--pJfKR"};